<template>
    <div id="app">
        <div class="view-container">
            <transition name="delay-main">
                <Main class="view main-container" v-if="isMain" />
            </transition>
            <transition name="slide-about">
                <About class="view about-container" v-if="!isMain" />
            </transition>
        </div>
        <div class="menu-container">
            <FixedMenu />
        </div>
    </div>
</template>

<script>
    import FixedMenu from '@/components/FixedMenu';
    import Main from '@/views/Main';
    import About from '@/views/About';
    export default {
        name: 'App',
        components: { Main, About, FixedMenu },
        data: function () {
            return {
                isMain: true,
            };
        },
        beforeMount() {
            const currentRoute = this.$router.currentRoute;
            if (currentRoute.name === 'main' || currentRoute.name === 'topic') {
                this.isMain = true;
            } else if (currentRoute.name === 'about') {
                this.isMain = false;
            }
        },
        watch: {
            $route(to) {
                if (to.name === 'main' || to.name === 'topic') {
                    this.isMain = true;
                } else if (to.name === 'about') {
                    this.isMain = false;
                }
            },
        },
    };
</script>

<style lang="scss">
    #app {
        font-family: 'Titillium Web', Avenir, sans-serif;
        //font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;

        .view-container {
            position: relative;
            width: 100vw;
            height: 100vh;
            // overflow-x: hidden;
        }

        .view {
            position: absolute;
            left: 0;
            top: 0;
        }

        .main-container {
            z-index: 1;
        }

        .about-container {
            z-index: 200;
            left: 0;
        }

        .menu-container {
            position: fixed;
            z-index: 999;
        }
    }

    .delay-main-enter-active,
    .delay-main-leave-active {
        //transition: opacity 0.4s;
        transition-delay: 0.4s;
    }

    .delay-main-enter,
    .delay-main-leave-to {
        //opacity: 0;
    }

    .slide-about-enter-active,
    .slide-about-leave-active {
        transition: transform 0.4s;
    }

    .slide-about-enter,
    .slide-about-leave-to {
        transform: translateX(100vw);
    }
</style>
